import { useState, useEffect } from 'react';
import { Row, Col, Descriptions, Divider } from 'antd';
import { BaseSection, TitleLayout } from 'components/layouts';
import { BaseContainer } from 'components/containers';
import { boardData, scheduleData } from 'data/hq/dashboard';
import { DataGrid } from 'components/elements';
import { getCommonInfoMemberAPI, getCommonInfoSchoolAPI } from 'api/common';
import { getHqScheduleAPI, getHqScheduleTop5API } from 'api/schedule';
import { getDashboardTop5NewTaskListAPI } from 'api/dashboard';
import { boardTaskTypeOptions, scheduleTypeOptions } from 'data/options';
import { fnGetToday } from 'utils/utils';
import dayjs from 'dayjs';

export default function Home() {
  const [loading, setLoading] = useState({ schedule: false, board: false });
  const [schedule, setSchedule] = useState([]);
  const [dataBoard, setDataBoard] = useState([]);
  const [member, setMember] = useState([]);
  const [school, setSchool] = useState([]);

  const getMemberList = async () => {
    const params = { yyyymm: dayjs().format('YYYYMM').split('-').join('') };
    try {
      await getCommonInfoMemberAPI(0, { params }).then((res) => {
        if (res.status === 200) {
          const resdata = res.data.data_info;
          const item = [
            {
              key: 'REGULAR_MEMBER',
              label: '정회원수',
              children: resdata?.REGULAR_MEMBER || 0
            },
            {
              key: 'ORDER_MEMBER',
              label: '총주문수',
              children: resdata?.ORDER_MEMBER || 0
            },
            {
              key: 'INCREASE_REGULAR_MEMBER',
              label: '순증',
              children: (resdata?.PRESENCE_MEMBER || 0)+(Number(resdata?.RE_PRESENCE_MEMBER) || 0)-(resdata?.CANCEL_MEMBER || 0)
            },
            {
              key: 'PRESENCE_MEMBER',
              label: '입회',
              children: resdata?.PRESENCE_MEMBER || 0
            },
            {
              key: 'CANCEL_MEMBER',
              label: '휴회',
              children: resdata?.CANCEL_MEMBER || 0
            },
            {
              key: 'RE_PRESENCE_MEMBER',
              label: '재입회',
              children: resdata?.RE_PRESENCE_MEMBER || 0
            }
          ];
          setMember(item);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
  const getInfoSchoolList = async () => {
    const params = { yyyymm: dayjs()?.format('YYYYMM')?.split('-')?.join('') };
    try {
      await getCommonInfoSchoolAPI(0, { params }).then((res) => {
        if (res.status === 200) {
          const resdata = res.data.data_info;
          // console.log("***",resdata)
          const item = [
            {
              key: 'BEFORE_SCHOOL',
              label: '개원전',
              children: resdata?.BEFORE_SCHOOL || 0
            },
            {
              key: 'CANCEL_SCHOOL',
              label: '해지',
              children: resdata?.CANCEL_SCHOOL || 0
            },
            {
              key: 'CLOSE_SCHOOL',
              label: '휴업',
              children: resdata?.CLOSE_SCHOOL || 0
            },
            {
              key: 'RUN_SCHOOL',
              label: '운영중',
              children: resdata?.RUN_SCHOOL || 0
            },
            {
              key: 'SALES_DOWN_SCHOOL',
              label: '영업부진',
              children: resdata?.SALES_DOWN_SCHOOL || 0
            },
            {
              key: 'TOTAL_SCHOOL',
              label: '총 교육원',
              children: resdata?.TOTAL_SCHOOL || 0
            }
          ];
          setSchool(item);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getScheduleList = async () => {
    try {
      await getHqScheduleTop5API().then((res) => {
        if (res.status === 200) {
          setSchedule(res.data.data_list);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getDashboardNewTaskList = async () => {
    try {
      await getDashboardTop5NewTaskListAPI().then((res) => {
        if (res.status === 200) {
          console.log(res.data.data_list);
          setDataBoard(res.data.data_list);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getMemberList();
    getInfoSchoolList();
    getScheduleList();
    getDashboardNewTaskList();
  }, []);

  const items1 = [
    {
      key: '1',
      label: '가맹 목표',
      children: '100'
    },
    {
      key: '2',
      label: '당월 계약',
      children: '100'
    },
    {
      key: '3',
      label: '누적 계약',
      children: '100'
    },
    {
      key: '4',
      label: '목표 성취율',
      children: '100'
    },
    {
      key: '5',
      label: '당월 가맹상담',
      children: '100'
    },
    {
      key: '6',
      label: '당월 해지',
      children: '100'
    },
    {
      key: '7',
      label: '해지율',
      children: '100'
    }
  ];

  const items2 = [
    {
      key: '1',
      label: '정회원수',
      children: '100'
    },
    {
      key: '2',
      label: '총 주문수',
      children: '100'
    },
    {
      key: '3',
      label: '입회',
      children: '100'
    },
    {
      key: '4',
      label: '재입회',
      children: '100'
    },
    {
      key: '5',
      label: '휴회',
      children: '100'
    },
    {
      key: '6',
      label: '졸업',
      children: '100'
    },
    {
      key: '7',
      label: '순증',
      children: '100'
    },
    {
      key: '8',
      label: '입회율',
      children: '100'
    },
    {
      key: '9',
      label: '순회율',
      children: '100'
    }
  ];

  const columnsSchedule = [
    {
      title: '분류',
      align: 'center',
      dataIndex: 'NOTICE_TYPE',
      render: (text) => {
        return scheduleTypeOptions?.filter((it) => it?.value === text)[0]?.label;
      }
    },
    {
      title: '제목',
      align: 'center',
      dataIndex: 'TITLE'
    },
    {
      title: '시행일',
      align: 'center',
      dataIndex: 'ONEDAY',
      render: (text, record) => {
        return text ? record?.START_DATE : `${record?.START_DATE} ~ ${record?.END_DATE}`;
      }
    },
    {
      title: '작성일',
      align: 'center',
      dataIndex: 'REGIST_DATE'
    }
  ];

  const columnsBoard = [
    {
      title: '분류',
      align: 'center',
      dataIndex: 'BOARD_TYPE',
      render: (text) => {
        return boardTaskTypeOptions?.filter((it) => it?.value === text)[0]?.label;
      }
    },
    {
      title: '제목',
      align: 'center',
      width: '50%',
      dataIndex: 'TITLE'
    },
    {
      title: '작성일',
      align: 'center',
      dataIndex: 'REGIST_DATE'
    }
  ];

  return (
    <BaseSection>
      <BaseContainer alignItems="start">
        <TitleLayout>교육원 실적</TitleLayout>
        <Divider className="divider-small" />
        <Descriptions bordered layout="vertical" column={7} labelStyle={{ textAlign: 'center' }} contentStyle={{ textAlign: 'center' }} items={school} />
        <Divider className="divider" />
        <TitleLayout>회원 실적</TitleLayout>
        <Divider className="divider-small" />
        <Descriptions bordered layout="vertical" column={9} labelStyle={{ textAlign: 'center' }} contentStyle={{ textAlign: 'center' }} items={member} />
        <Divider className="divider" />
        <Row>
          <Col span={12} style={{ paddingRight: '4px' }}>
            <TitleLayout>일정 관리</TitleLayout>
            <Divider className="divider-small" />
            <DataGrid rowKey={(record) => `${record?.key}${record?.TITLE}`} columns={columnsSchedule} data={schedule} loading={loading.schedule} />
          </Col>
          <Col span={12} style={{ paddingLeft: '4px' }}>
            <TitleLayout>게시판(신규게시물)</TitleLayout>
            <Divider className="divider-small" />
            <DataGrid rowKey={'key'} columns={columnsBoard} data={dataBoard} loading={loading.board} />
          </Col>
        </Row>
      </BaseContainer>
    </BaseSection>
  );
}
